import { render, staticRenderFns } from "./app-user-details.vue?vue&type=template&id=4386c8ba&scoped=true&"
import script from "./app-user-details.vue?vue&type=script&lang=js&"
export * from "./app-user-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4386c8ba",
  null
  
)

export default component.exports